import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVodafoneComponent } from './simple-icons-vodafone.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVodafoneComponent ],
    exports:      [ SimpleIconsVodafoneComponent ],
    bootstrap:    []
})
export class SimpleIconsVodafoneModule {}
